import $ from 'jquery';

import BrowserCheck from './BrowserCheck';
import Header from './Header';
import Footer from './Footer';
import TermNavigation from './TermNavigation';
import Toolbar from './Toolbar';
import GenerateHeadingAnchors from './GenerateHeadingAnchors';
import Anchors from './Anchors';
import MenuExport from './MenuExport';

// Add the theme behaviors

$(document).ready(() => {
  // Helpers

  const $body = $(document.body);

  // Main/Primary Site Navigation
  const navigation = document.getElementById('navigation');

  // Fetch navigation from host site.
  navigation.MenuExport = new MenuExport($body);

  // Get browser and version
  $('body').each((i, element) => {
    if (!element.browserCheck) {
      element.browserCheck = new BrowserCheck(element);
    }
  });

  // Controls the states of the menu and search states
  $('.site-toolbar').each((i, element) => {
    if (!element.toolbar) {
      element.toolbar = new Toolbar(element);
    }
  });

  // Controls the page overlay display
  $('.overlay').bind('click', () => {
    $body.removeClass('menu-active search-active');
  });

  // Fixed Header using Headroom.js
  $('.headroom').each((i, element) => {
    if (!element.headroom) {
      element.headroom = new Header(element);
    }
  });

  // Term Navigation
  $('.term-nav').each((i, element) => {
    if (!element.termNavigation) {
      element.termNavigation = new TermNavigation(element);
    }
  });

  // Generate Headings Anchors
  $('.node-full .node-content, .overview .node-content').each((i, element) => {
    if (!element.GenerateHeadingAnchors) {
      element.GenerateHeadingAnchors = new GenerateHeadingAnchors(element);
    }
  });

  // Add and manage hash/anchor functionality

  if (!document.body.Anchors) {
    document.body.Anchors = new Anchors();
  }

  // Smart Footer
  $('.page-footer').each((i, footer) => {
    const $footprint = $('.footprint');
    if (!footer.smartFooter && $footprint.length) {
      footer.smartFooter = new Footer(footer, $footprint);
    }
  });
});



// WEBPACK FOOTER //
// ./theme.export.js